import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const UpdateAppOnboardingStatusModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  appOnboardingStatus, onAppOnboardingStatusChange, appOnboardingStatusList, appOnboardingStatusError, setAppOnboardingStatusError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update App Onboarding Status'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='text' name='appOnboardingStatus' label='App Onboarding Status'
      value={appOnboardingStatus} onChange={onAppOnboardingStatusChange} optionList={appOnboardingStatusList}
      error={appOnboardingStatusError} setError={setAppOnboardingStatusError}
    />
  </ModalFormUI>

export default UpdateAppOnboardingStatusModalUI

